export const getScrollEl = () => document.querySelector('.simplebar-content-wrapper');
export const getContainerBody = () => document.querySelector('.container-body');
